var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { ArrayMaxSize, ArrayMinSize, ArrayNotEmpty, IsInt, IsNumber, IsOptional, IsPositive, IsString, Matches, MaxLength, ValidateNested, } from "class-validator";
import { IsValidDateString } from "./is-valid-date-string";
import { safeAssign } from "./safe-assign";
export class SpecialPaymentDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], SpecialPaymentDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], SpecialPaymentDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsValidDateString(),
    __metadata("design:type", String)
], SpecialPaymentDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], SpecialPaymentDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], SpecialPaymentDTO.prototype, "wageType", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Number)
], SpecialPaymentDTO.prototype, "amount", void 0);
export function toSpecialPaymentDTO({ id, employeeId, date, name, wageType, amount, }) {
    return new SpecialPaymentDTO({ id, employeeId, date, name, wageType, amount });
}
export class GetSpecialPaymentsDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsValidDateString(),
    __metadata("design:type", String)
], GetSpecialPaymentsDTO.prototype, "from", void 0);
__decorate([
    Expose(),
    IsValidDateString(),
    __metadata("design:type", String)
], GetSpecialPaymentsDTO.prototype, "to", void 0);
__decorate([
    Expose(),
    ArrayNotEmpty(),
    IsInt({ each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], GetSpecialPaymentsDTO.prototype, "employees", void 0);
export class SpecialPaymentValuesDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsValidDateString(),
    __metadata("design:type", String)
], SpecialPaymentValuesDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    IsString(),
    Matches(/\S/),
    MaxLength(255),
    __metadata("design:type", String)
], SpecialPaymentValuesDTO.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    Matches(/\S/),
    MaxLength(50),
    __metadata("design:type", String)
], SpecialPaymentValuesDTO.prototype, "wageType", void 0);
__decorate([
    Expose(),
    IsNumber({ maxDecimalPlaces: 2 }),
    IsPositive(),
    __metadata("design:type", Number)
], SpecialPaymentValuesDTO.prototype, "amount", void 0);
export class CreateSpecialPaymentDTO extends SpecialPaymentValuesDTO {
    constructor(props) {
        super(props);
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], CreateSpecialPaymentDTO.prototype, "employeeId", void 0);
/** Single and bulk entry share this list; it is saved all or nothing. */
export class CreateSpecialPaymentsDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    ArrayMinSize(1),
    ArrayMaxSize(1000),
    ValidateNested({ each: true }),
    Type(() => CreateSpecialPaymentDTO),
    __metadata("design:type", Array)
], CreateSpecialPaymentsDTO.prototype, "payments", void 0);
export class UpdateSpecialPaymentDTO extends SpecialPaymentValuesDTO {
    constructor(props) {
        super(props);
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], UpdateSpecialPaymentDTO.prototype, "id", void 0);
//# sourceMappingURL=special-payment.dto.js.map